import { Link } from "react-router-dom";
import TablePagination from "../components/TablePagination";
import { ReactElement } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faPrint } from "@fortawesome/free-solid-svg-icons";

interface TablePageProps {
  title: string;
  subTitle?: string;
  backUrl?: string;
  columns: any[];
  fetch: (pageIndex: number, pageSize: number) => Promise<any>;
  refresh?: boolean;
  showSubHeader?: boolean;
  totalRecords?: number;
  labelTotalRecords?: string;
  options?: ReactElement;
  showPrintButton?: boolean;
  printButtonLabel?: string;
  handlePrint?: () => void;
  runningPrint?: boolean;
  showAddButton?: boolean;
  handleAdd?: () => void;
  messageEmpty?: string | ReactElement;
  extraHeaderButtons?: ReactElement;
  pageNo?: number;
  backButtonAction?: () => void;
}

const TablePage = (props: TablePageProps) => {
  return <div id="page-list">
      <div className="uk-card uk-card-default uk-card-small uk-card-hover uk-margin-bottom">
        <div className="uk-card-header">
          <div className="uk-grid-small uk-flex-middle" uk-grid="true">
            <div className="uk-width-expand@m">
              <h3 className="uk-card-title uk-margin-remove-bottom">
                {props.title}
              </h3>
              {props.subTitle && <h5 className="uk-text-meta uk-text-small uk-margin-remove-top">{props.subTitle}</h5>}
            </div>
            {props.showAddButton &&
                <button
                  type="button"
                  className="uk-button uk-button-success uk-button-small uk-flex uk-flex-middle uk-margin-small-right"
                  onClick={() => props.handleAdd && props.handleAdd()}
                >
                  <span>Adicionar</span>
                  <FontAwesomeIcon className="uk-margin-small-left" icon={faPlus} />
                </button>
              }
            {props.extraHeaderButtons &&
              <div className="uk-margin-small-right">
                {props.extraHeaderButtons}
            </div>}
            {props.backUrl &&          
              <Link
                className="uk-button uk-button-primary uk-button-small"
                to={props.backUrl}
              >
                Voltar
              </Link>
            }
            {props.backButtonAction &&
              <a
                className="uk-button uk-button-primary uk-button-small"
                onClick={props.backButtonAction}
              >
                Voltar
              </a>
            }
          </div>
        </div>
        <div className="uk-card-body uk-padding-remove-top uk-margin-xsmall-top">
          {props.showSubHeader &&
            <div className="uk-flex uk-flex-middle">
              {props.labelTotalRecords &&
                <div className="uk-margin-right">
                  <span className="uk-badge uk-badge-primary uk-text-nowrap uk-padding-small uk-margin-xsmall-bottom">
                    {props.labelTotalRecords}
                  </span>
                </div>
              }
              {props.showPrintButton &&
                <button
                  type="button"
                  className="uk-button uk-button-primary uk-button-small uk-flex uk-flex-middle"
                  disabled={props.runningPrint || props.totalRecords == 0}
                  onClick={() => props.handlePrint && props.handlePrint()}
                >
                  <span>
                    {props.printButtonLabel ? props.printButtonLabel : 'Imprimir'}
                  </span>
                  {props.runningPrint ? (
                    <div
                      className="uk-margin-small-left"
                      uk-spinner="true; ratio:0.5"
                    ></div>
                  ) : (
                    <FontAwesomeIcon className="uk-margin-small-left" icon={faPrint} />
                  )}
                </button>
              }
            </div>
          }
          {props.options}
          <TablePagination
            columns={props.columns}
            fetchData={props.fetch}
            refresh={props.refresh}
            messageEmpty={props.messageEmpty}
            pageNo={props.pageNo}
          />
        </div>
      </div>
    </div>;
}
export default TablePage;